import React, {useEffect, useState} from 'react'
import {Box, Text, FormField,Select,Card,CardHeader,CardBody,CardFooter,Spinner, Button,Tip, NameValueList, NameValuePair,Layer, CheckBoxGroup,DataTable} from 'grommet'
import {FormDown,Catalog, Filter, Location, Organization, Close} from 'grommet-icons';
import AddressSummary from './addressSummary'
import EditAddressLayer from './editAddressLayer';
import {PostalCodeRequired,FilterLocations} from './utils/shared/shared'
import {APIRequest} from './utils/shared/requests'
import {withRouter} from 'react-router-dom'

function DropdownTip(props){
  const postCodeRequired = PostalCodeRequired(props.option.country.CountryCode)
  return (
    <Box margin={{left:'small'}} pad="small" gap="small" width={{ max: 'medium' }} round="small" background="background-front" responsive={false}>
              <Box direction='row'><Organization color='brand' /><Text margin={{left:'small'}} weight="bold">{props.option.name}</Text></Box>
              <>
                <NameValueList direction='row'>
                  <NameValuePair  name={<Text size='small' weight='bold'>Country</Text>}>
                    <Text size='small'>{props.option.country.CountryName}</Text>
                  </NameValuePair>
                  <NameValuePair name={<Text size='small' weight='bold'>City</Text>}>
                    <Text size='small' >{props.option.city}</Text>
                  </NameValuePair>
                  {postCodeRequired && (
                    <NameValuePair name={<Text size='small' weight='bold'>Postal Code</Text>}>
                    <Text size='small' >{props.option.postcode}</Text>
                    </NameValuePair>
                  )}
                </NameValueList>
              </>
            </Box>
  )
}

function returnEditButton(props){
  if (props.props.username === 'iluminada.moreno@bureauveritas.com' && props.props.locationType === 'destination'){
    return false 
  } else if (props.props.username === 'ops.eu@petro-inspect.com' && props.props.locationType === 'destination'){
    return false
   } else {
    return true
  }
}


function showDestinationOptions(props){
  if (props.props.username === 'ops.eu@petro-inspect.com' && props.props.locationType === 'destination'){
    return false 
  } else {
    return true
  }
}

function LocationCard(props){
  const showEdit = returnEditButton(props)
  const displayDestinationDropdown = showDestinationOptions(props)
  const defaultOptions = props.defaultLocations
  const [locations, setLocations] = useState(props.locations)
  const [showFilter, setShowFilter] = useState()
  const [filterOption, setFilterOption] = useState(['all'])
  const [filterOptions, setFilterOptions] = useState([{value:'all', label: 'All Locations'},{value:'Address', label: 'My Address Book',disabled:true}, {value:'Customer', label:'My Customers',disabled:true},{value:'Organisation', label: 'My Organisation',disabled:true}])
  const returnFilterOptions = (option) => {
    if (option.includes('all')){
      setFilterOptions([{value:'all', label: 'All Locations', },{value:'Address', label: 'My Address Book',disabled:true}, {value:'Customer', label:'My Customers',disabled:true},{value:'Organisation', label: 'My Organisation',disabled:true}])
    } else {
      setFilterOptions([{value:'all', label: 'All Locations', },{value:'Address', label: 'My Address Book'}, {value:'Customer', label:'My Customers'},{value:'Organisation', label: 'My Organisation'}])
    }
  }
  return (
    <Card alignSelf='center' elevation='large' margin='small' background='background-front' style={{minWidth: 550,minHeight:600}}>
      <CardHeader margin='small' direction='row' justify='start'><Location margin='small' color='status-ok'/><Text weight='bold' style={{marginLeft: 5, marginTop:2}}>{props.props.locationType.charAt(0).toUpperCase() + props.props.locationType.slice(1)} Details</Text>
      {/* <Select margin={{left:'small'}} icon={<FormDown />} size='small' placeholder={"Select Locations..."} id="select" options={["All Locations", "Labs", "Customers"]} value={locationOption} onChange={({ option }) => {setLocationOption(option)}} onClose={() => {props.setLocations(defaultOptions)}}/> */}
      </CardHeader>
      <CardBody pad='small' direction='column'>
       {displayDestinationDropdown && (
         <Box direction='row'>
         <FormField icon={<Catalog />} label={<Box direction='row'><Catalog color='brand'/><Text margin={{left:'xsmall', top:'xxsmall'}} size='small'>Address Book</Text></Box>}style={{maxWidth:380}}>
         <Select help={"Filter Location"} style={{borderStyle: 'solid', maxWidth: 320, minWidth: 290}} margin='small' icon={<FormDown />} size='small' placeholder={'Select Address...'} id="select"  valueKey={'key'} options={locations} value={props.props.shipmentLocation} onChange={({ option }) => {props.props.setLocation(option, props.props.locationType); props.setLocationName(option.name)}} 
             onClose={() => {props.setLocations(defaultOptions)}}
             onSearch={text => { 
               const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
               const exp = new RegExp(escapedText, 'i') 
               setLocations(defaultOptions.filter(o => exp.test(o.name), props.props.locationType)); 
             }} 
             labelKey={(option) => {return(<Tip plain dropProps={{ align: { right: 'left' } }}content={<DropdownTip option={option}/>}>{option.name}</Tip>)}}
             />
         </FormField>
         <Box margin={{top:'xxsmall', left:'small'}}><Button margin={{top:'large'}} onClick={() => {setShowFilter(true)}} hoverIndicator primary label='Filter' size='small'  icon={<Filter />} /></Box>
           {showFilter && (
             <Layer onEsc={() => {setShowFilter(false); FilterLocations(filterOption, setLocations, props.locations)}} margin='small' width='large'>
               <Box width='xlarge'>
               {(props.props.user === 'Agent' ? null :
                 <Button margin={'small'} size='small' hoverIndicator label='View Address Book' icon={<Catalog />} primary onClick={() => {props.props.history.push({pathname: '/addresses/all'})}} />)}
                 <Box direction='row' justify='between'><Button margin={'small'} icon={<Close />} onClick={() => {setShowFilter(false);FilterLocations(filterOption, setLocations, props.locations)}}/> <Text weight='bold' margin={{top:'medium', right: 'small'}}>Filter Addresses</Text><Box></Box></Box>
                 <>
                 {(props.props.user === 'Agent' ? null :
                 <Box pad="medium">
                   <CheckBoxGroup direction='row' valueKey={'value'} labelKey={'label'} value={filterOption}  onChange={({value: nextValue }) => {setFilterOption(nextValue);FilterLocations(nextValue, setLocations, props.locations); returnFilterOptions(nextValue);}}  options={filterOptions} />
                 </Box>
                  )}
                 <Box pad='medium' overflow={'scroll'}> 
                   <DataTable elevation='medium' overflow='scroll' onClickRow={(option) => {props.props.setLocation(option.datum, props.props.locationType); setShowFilter(undefined)}} round margin='small' background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }}} paginate step={10} pad={{ horizontal: 'xsmall', vertical: 'small' }} columns={[{header:"Name",property:"name", search:true}, {header:"Country",property:"address.Country.CountryName",sortable:true,search:false},{header:"City",property:"address.City",sortable:true,search:false},{header:"Contact",property:"primary_contact_person",sortable:true,search:false},{header:"Type",property:`location_type`,sortable:true,search:false} ]}   data={locations} />
                 </Box>
                 </>
               </Box>
             </Layer>
           )}
     </Box>
       )}
      <Box>
      <AddressSummary size={props.props.size} lab={props.props.shipmentLocation} setLocation={props.props.setLocation}/>
      </Box>
        </CardBody>
        <CardFooter>
          {showEdit && (
            <EditAddressLayer user={props.props.user} addressType={props.props.locationType} shipmentLocation={props.props.shipmentLocation} setLocation={props.props.setLocation}/>
          )}  
        </CardFooter>
    </Card> 
  )
}

function LoadingLocationCard(props){
  return (
    <Card alignSelf='center'  height='medium' margin='small' width="medium"  background='disabled' style={{minWidth: 700, minHeight: 500}}>
  <CardHeader margin='small' direction='row'>
    <Box direction='row'>
      <Location margin='small' color='status-warning'/><Text color='light-2' weight='bold' style={{marginLeft: 5, marginTop:2}}>{props.props.locationType.charAt(0).toUpperCase() + props.props.locationType.slice(1)}</Text>
    </Box>
  </CardHeader>
  <CardBody align='center' justify='center'><Spinner /></CardBody>
  </Card>
  )
}


function fetchLocations(setLocations,setLocationName,setLoad,props,destinationType,setDefaultLocations){
  setLoad(true)
  APIRequest('/locations').then(result => {
    setLocations(result.locations)
    setDefaultLocations(result.locations)
    if (result.locations.length === 0){
      props.setLocation({ name: 'Select Address', contact:{ contactName: "",companyName: "",contactPhone: "",contactEmail: ""},address_line_one: "",address_line_two: "",address_line_three: "",country: {CountryCode: "", CountryName: ""},city: "",PostCode: ""}, props.locationType)
    } else {
      if (Array.isArray(result.locations) && result.locations.length > 0){
        if (props.reship){
          setLoad(false)
          return
        } else {  
          props.setLocation(result.default_origin, 'origin')
          if (props.username === 'ops.eu@petro-inspect.com'){
            props.setLocation(result.destination, 'destination')
          } else {
            props.setLocation(result.locations[1], 'destination')
          }
        }
        // setLocationName(result[0].name)
      if (destinationType){destinationType(result.locations[0].destination_type)} 
    }
    }
    setLoad(false)
  })
 }

function ShipmentLocationCard(props){
  const destinationType = props.handleDestinationType
  const [locations, setLocations] = useState([]);
  const [defaultLocations, setDefaultLocations] = useState([]);
  const [load, setLoad] = useState()
  const [locationName, setLocationName] = useState()
  useEffect(() => {    
      fetchLocations(setLocations, setLocationName,setLoad, props, destinationType,setDefaultLocations)
   },[]);   
    if (load){
      return <LoadingLocationCard props={props} />
    } else {
      return <LocationCard props={props} locationName={locationName} defaultLocations={defaultLocations} setLocationName={setLocationName} locations={locations} setLocations={setLocations}/>
    }
}
export default withRouter(ShipmentLocationCard)
